import { createAction, props } from '@ngrx/store';
import { License } from '@cpd-app/core-module/models';

export const loadLicenses = createAction('[License/API] Load Licenses');

export const licensesLoadedSuccess = createAction(
  '[License/API] Licenses Loaded Success',
  props<{ licenses: License[] }>()
);

export const licensesLoadedFailure = createAction(
  '[License/API] Licenses Loaded Failure',
  props<{ error: any }>()
);

export const clearLicenses = createAction('[License/API] Clear Licenses');
